import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ModalWindow, SaveButton, SearchableDropdown, RequiredLabel } from '../common';

const emptyGuid = '00000000-0000-0000-0000-000000000000';

export class AddFormModal extends Component {

  render() {
    const { siteState, currentSelectedSite, handleUpdateSite,
      programState, currentSelectedProgram, handleUpdateProgram,
      show, onClose, onSave } = this.props;

    const { isFetching: isFetchingSites, data: pagedSites } = siteState || {};
    const siteData = pagedSites && pagedSites.results;

    const { isFetching: isFetchingPrograms, data: programData } = programState || {};
    const isSiteSelected = !!currentSelectedSite && currentSelectedSite !== emptyGuid;
    const isProgramSelected = !!currentSelectedProgram && currentSelectedProgram !== emptyGuid;

    const siteList = !!siteData ? siteData.map(site => { return { value: site.id, label: site.name } }) : [];
    const programList = !!programData ? programData.map(program => { return { value: program.id, label: program.name } }) : [];
    const isSiteDisabled = isFetchingSites || isFetchingPrograms;
    const isProgramDisabled = !isSiteSelected || isFetchingSites || isFetchingPrograms;
    const allowSaving = isSiteSelected && isProgramSelected && !isFetchingSites && !isFetchingPrograms;

    return (
      <ModalWindow show={show}
        id="select-site-modal"
        title="New Intake Form - Select Site and Program"
        footer={
          <div>
            <SaveButton
              id="create"
              text={"OK"}
              saving={false}
              onSave={e => onSave()}
              disabled={!allowSaving} />
            <button id="cancel" className="btn btn-default" onClick={e => onClose()}>
              Cancel
          </button>
          </div>
        }
        children={
          <div className="select-site-intake">
            <p>Select the Site / Program in which to enroll the Participants created when applicants complete this intake form.</p>
            <br />
            <form className="form-horizontal">
              <div className="form-group row">
                <div className="col-sm-2 col-form-label text-right">
                  <RequiredLabel isRequired={true} className="label-override" content={"Site"} htmlFor="site-select-dropdown-id" />
                </div>
                <div className="col-sm-10">
                  <SearchableDropdown
                    id="site-select-dropdown-id"
                    instanceId="1"
                    name="site-select-dropdown"
                    options={siteList}
                    value={currentSelectedSite || ""}
                    isDisabled={isSiteDisabled}
                    isLoading={isFetchingSites}
                    onChange={newValue => handleUpdateSite(newValue.value)}
                    autoFocus={true}
                  />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-sm-2 col-form-label text-right">
                  <RequiredLabel isRequired={true} className="label-override" content={"Program"} htmlFor="program-select-dropdown-id" />
                </div>
                <div className="col-sm-10">
                  <SearchableDropdown
                    id="program-select-dropdown-id"
                    instanceId="2"
                    name="program-select-dropdown"
                    options={programList}
                    value={currentSelectedProgram || ""}
                    isDisabled={isProgramDisabled}
                    isLoading={isFetchingPrograms}
                    onChange={newValue => handleUpdateProgram(newValue.value)}
                    autoFocus={false}
                  />
                </div>
              </div>
            </form>
          </div>
        }
        onClose={e => onClose()}
        contentId="confirm-enabled"
        css={{ body: "intake-modal-body" }} />
    );
  }
}

AddFormModal.propTypes = {
  show: PropTypes.bool,
  siteState: PropTypes.any,
  currentSelectedSite: PropTypes.string,
  handleUpdateSite: PropTypes.func,

  programState: PropTypes.any,
  currentSelectedProgram: PropTypes.string,
  handleUpdateProgram: PropTypes.func,

  onClose: PropTypes.func,
  onSave: PropTypes.func,
};

export default AddFormModal;
